module.exports = __webpack_public_path__ + "img/workaholics.c722035a.jpg";